import { render } from "./comprasinventariogeneralrestaurante.vue?vue&type=template&id=550d7842&scoped=true"
import script from "./comprasinventariogeneralrestaurante.vue?vue&type=script&lang=js"
export * from "./comprasinventariogeneralrestaurante.vue?vue&type=script&lang=js"

import "./comprasinventariogeneralrestaurante.vue?vue&type=style&index=0&id=550d7842&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550d7842"]])

export default __exports__